import { catchErrorInto, effect, Entity, exhaustMapWithTrailing, fromPromise, LiveData, onComplete, onStart } from '@toeverything/infra';
import type { WorkspaceService } from '../../workspace';
import type { WorkspaceTeamsStore } from '../stores/teams';
import { EMPTY, map, mergeMap } from 'rxjs';


export type TeamNode = {
  id: string;
  name: string;
  parentId?: string | null;
  children?: TeamNode[];
}

export class WorkspaceTeams extends Entity {
  constructor(
    private readonly store: WorkspaceTeamsStore,
    private readonly workspaceService: WorkspaceService
  ) {
    super();
  }

  teams$ = new LiveData<TeamNode[] | undefined>(undefined);

  isLoading$ = new LiveData(false);
  error$ = new LiveData<any>(null);

  readonly revalidate = effect(
    map(() => this.workspaceService.workspace.id),
    exhaustMapWithTrailing(workspaceId => {
      return fromPromise(async signal => {
        return this.store.fetchTeams(
          workspaceId,
          signal
        );
      }).pipe(
        mergeMap(data => {

          // 转换为树形结构
          const mapToTree = (nodes: TeamNode[]): TeamNode[] => {
            const map = new Map<string, TeamNode>();
            const roots: TeamNode[] = [];

            nodes.forEach(node => {
              map.set(node.id, { ...node, children: [] });
            });

            nodes.forEach(node => {
              if (node.parentId) {
                const parent = map.get(node.parentId);
                if (parent) {
                  parent.children!.push(map.get(node.id)!);
                }
              } else {
                roots.push(map.get(node.id)!);
              }
            });

            return roots;
          };
          const treeData = mapToTree(data);

          this.teams$.setValue(treeData);
          return EMPTY;
        }),
        onStart(() => {
          this.teams$.setValue(undefined);
          this.isLoading$.setValue(true);
        }),
        onComplete(() => this.isLoading$.setValue(false)),
        catchErrorInto(this.error$),
      );
    })
  );

  override dispose(): void {
    this.revalidate.unsubscribe();
  }

}